<template>
<div id="banner-form">

    <v-dialog v-model="dialog" persistent scrollable fullscreen>
        <v-card>
            <v-card-title class="text-h5 pl-6 font-weight-regular"><span>{{form.id?'Edit':'Add'}} Banner at Order Confirmation</span>
                <v-spacer/><v-switch v-model="form.isActive" label="Is Active" color="green" class="mt-n2" inset hide-details/>
            </v-card-title>
            <v-divider/>
            <v-card-text class="pb-0">
                <v-form ref="form">
                    <v-row>
                        <v-col cols="6">
                            <v-row>
                                <v-col cols="12">
                                    <label class="text-uppercase grey--text font-weight-bold">Banner Title*</label>
                                    <v-text-field outlined v-model="form.caption" class="mt-3" maxlength="30"
                                                  :rules="[v => v&&!!v.trim() || 'Banner Title Required.']"/>
                                </v-col>
                                <v-col cols="12" class="pt-0">
                                    <label class="text-uppercase grey--text font-weight-bold">Redirect To*</label>
                                    <v-autocomplete v-model="form.redirectTo" class="mt-3" outlined :items="Constants.redirectToOptions"
                                                    item-text="name" item-value="id" :rules="[v => !!v || 'Please select Redirect To']"/>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="6">
                            <v-row>
                                <v-col cols="12" class="">
                                    <label class="text-uppercase grey--text font-weight-bold">Attach Image*</label>
                                    <input id="file" @change="onSelectFile" type="file" accept="image/*,.jfif" v-if="dialog" style="display: none"/>
                                    <div class="image-div mt-3" @click="openFile">
                                        <ImageBox :imageLoading="imageLoading" :imageUrl="imgForm.path" icon="upload"></ImageBox>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="6" v-if="form.redirectTo === Constants.RedirectTo.Url">
                            <label class="text-uppercase grey--text font-weight-bold">URL*</label>
                            <v-text-field outlined v-model="form.redirectUrl" class="mt-3"
                                          :rules="[value => !!value || 'URL Required.']"/>
                        </v-col>
                        <v-col cols="6" v-if="[Constants.RedirectTo.Call, Constants.RedirectTo.Whatsapp].includes(form.redirectTo)">
                            <label class="text-uppercase grey--text font-weight-bold">
                                {{form.redirectTo === Constants.RedirectTo.Whatsapp?'Whatsapp':''}} Number*</label>
                            <v-text-field outlined v-model="form.mobile" class="mt-3" type="number"
                                          :rules="[v => !!v || 'Number Required',v => v && v.length === 10 || 'Mobile Number Must be 10 Digits']"/>
                        </v-col>
                        <v-col cols="12" v-if="form.redirectTo === Constants.RedirectTo.Whatsapp">
                            <label class="text-uppercase grey--text font-weight-bold">Whatsapp Default Message*</label>
                            <v-textarea outlined v-model="form.whatsappMessage" class="mt-3" rows="3"
                                        :rules="[v => v&&!!v.trim() || 'Whatsapp Message Required.']"/>
                        </v-col>
                        <v-col cols="12">
                            <label class="text-uppercase grey--text font-weight-bold">Schedule</label>
                            <v-radio-group class="mt-3" row outlined dense v-model="form.isSchedule" @change="onChangeSchedule">
                                <v-radio label="Now" :value="false"></v-radio>
                                <v-radio label="Schedule" :value="true"></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col cols="6">
                            <label class="text-uppercase grey--text font-weight-bold">Start Time*</label>
                            <v-datetime-picker v-model="form.startTime" dateFormat="dd-MM-yyyy" timeFormat="hh:mm a" :disabled="!form.isSchedule"
                                               :textFieldProps="{outlined:'outlined', rules: [v => !!v || 'Start Time required']}"
                                               :datePickerProps="{min: moment().format('YYYY-MM-DD')}">
                                <template v-slot:dateIcon><v-icon>mdi-calendar</v-icon></template>
                                <template v-slot:timeIcon><v-icon>mdi-clock</v-icon></template>
                            </v-datetime-picker>
                        </v-col>
                        <v-col cols="6"><!--v => moment(form.endTime).format('YYYY-MM-DD HH:mm')>moment(form.startTime).format('YYYY-MM-DD HH:mm') || 'End Time should be greater than Start Time' -->
                            <label class="text-uppercase grey--text font-weight-bold">End Time*</label>
                            <v-datetime-picker v-model="form.endTime" dateFormat="dd-MM-yyyy" timeFormat="hh:mm a"
                                               :textFieldProps="{outlined:'outlined', rules: [v => !!v || 'End Time required',
                                                 v => moment(form.endTime).unix()>moment(form.startTime).unix() || 'End Time should be greater than Start Time']}"
                                               :datePickerProps="{min: form.startTime?moment(form.startTime).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')}">
                                <template v-slot:dateIcon><v-icon>mdi-calendar</v-icon></template>
                                <template v-slot:timeIcon><v-icon>mdi-clock</v-icon></template>
                            </v-datetime-picker>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="mt-5">
                <v-spacer></v-spacer>
                <v-btn class="text-capitalize white elevation-0" text @click="closeDialog">Close</v-btn>
                <v-btn class="primary px-3 text-capitalize" :loading="formLoading" dark @click="handleSubmit">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <Snackbar :toaster="toaster"></Snackbar>
</div>
</template>

<script>
import Constants from "../../Constants/Constants";
import NetworkCommunicator from "../../plugins/NetworkResourceHandler";
import Snackbar from "../../components/Common/Snackbar";
import ImageBox from "../../components/Common/ImageBox";
import {CREATE_UPDATE_BANNER} from "../../graphql/mutations/Banners";
import moment from "moment";
let user = JSON.parse(localStorage.user);
let toaster = { enable: false, color: 'green', message: '' };
let form = {caption:'', redirectTo:4, redirectUrl:null, mobile:null, whatsappMessage:null, isActive:true, isSchedule:false,
    createdBy:user.id, updatedBy:user.id, startTime:new Date(), endTime:moment().add(1, 'day').toDate(),
    bannerType:Constants.BannerType.OrderConfirmation};
let imgForm = {path:'', createdBy:user.id, updatedBy:user.id};
export default {
    name: "BannerOCForm",
    components: {ImageBox, Snackbar},
    props: ['dialog', 'banners'],
    data(){
        return{
            Constants, moment,
            form: {...form},
            imgForm: {...imgForm},
            formLoading: false,
            imageLoading: false,
            toaster: toaster
        }
    },
    watch:{
        'dialog': function(val){
            if(val && !this.form.id){
                this.form.startTime = new Date();
                this.form.endTime = moment().add(1, 'day').toDate();
            }
        }
    },
    methods:{
        openFile(){
            document.getElementById('file').click();
        },
        onSelectFile(evt){
            this.imageLoading = true;
            let file = evt.target.files[0];
            if(!file) return this.imageLoading = false;
            let formData = new FormData();
            formData.append('image', file);
            formData.append('name', file.name);
            NetworkCommunicator('POST', Constants.api_url + 'v1/upload', formData).then(res => {
                if(res.flag){
                    this.imgForm.path = res.data
                }else{
                    this.toaster = {...toaster, enable:true, message: 'Image Upload Failed'}
                }
                this.imageLoading = false
            }).catch(function(err){
                console.log('Upload File Error', err)
                this.toaster = {...toaster, enable:true, message: 'Image Upload Failed'}
                this.imageLoading = false
            })
        },
        onChangeSchedule(val){
            if(!val) this.form.startTime = moment().toDate();
        },
        onEditBanner(item){
            Object.copyExistingKeys(this.form, item);
            if(item.BannerImages.length) {
                Object.copyExistingKeys(this.imgForm, item.BannerImages[0]);
                this.imgForm.id = item.BannerImages[0].id;
            }
            this.form.id = item.id;
            this.form.startTime = moment(item.startTime).toDate();
            this.form.endTime = moment(item.endTime).toDate();
        },
        handleSubmit(){
            if(this.$refs.form.validate() && this.imgForm.path)
                this.checkBannerOverlap();
            else if(this.$refs.form.validate() && !this.imgForm.path)
                this.toaster = {color: 'red', enable:true, message: 'Please attach Image'}
        },
        checkBannerOverlap(){
            let banners = this.banners.filter(b => b.id !== this.form.id);
            let overlap = banners.find(b => !(moment(this.form.startTime).unix() >= moment(b.endTime).unix()
                || moment(this.form.endTime).unix() <= moment(b.startTime).unix()));
            if(!overlap) this.saveBanner();
            else this.toaster = {color: 'red', enable:true, message: `Cannot add as banner exist with date ${moment(overlap.startTime).format('DD-MM-YYYY hh:mm A')} &
                                    ${moment(overlap.endTime).format('DD-MM-YYYY hh:mm A')}`}
        },
        async saveBanner(){
            this.formLoading = true;
            this.form.id = this.form.id || Constants.generateUUID();

            let response = await this.$apollo.mutate({
                mutation: CREATE_UPDATE_BANNER,
                variables: {
                    banner: {sequenceNo: this.banners.length, ...this.form, imageUrl:this.imgForm.path},
                    updateColumns: [...Object.keys(this.form), 'updatedBy'],
                    attachments: {...this.imgForm, bannerId:this.form.id},
                    updateColumnsAttachment: ['path', 'createdBy', 'updatedBy'],
                    deleteAttachmentIds: []
                }
            })
            this.formLoading = false;
            this.toaster = {enable:true, color:'green', message: `Banner at Order Confirmation saved Successfully`};
            if(response.data) this.closeDialog()
        },
        closeDialog(){
            this.$refs.form.resetValidation();
            this.imageLoading = false;
            this.form = {...form};
            this.imgForm = {...imgForm};
            this.$emit('update:dialog', false)
        }
    }
}
</script>

<style scoped>
    .image-div{
        width: 400px;
        height: 190px;
    }
    .mt-24{
        margin-top: 96px;
    }
</style>
